/**
 Copyright Highway9 Networks Inc.
 */
import { AccessConfig, AccessConfigTemplate, DefaultRadioManager } from "~/types/accessConfig";
import APIService from "./APIServices";

const AccessConfigAPI = new APIService<AccessConfig>("accessConfig");
const DefaultRadioManagerAPI = new APIService<DefaultRadioManager>("defaultRadioManager");

export const accessConfigService = {
  getAccessConfigData,
  createRif: AccessConfigAPI.create,
  updateRif: AccessConfigAPI.update,
  deleteRif: AccessConfigAPI.delete,
  getAccessConfigTemplate : () => AccessConfigAPI.get<AccessConfigTemplate[]>('template'),

  getDefaultRadioManagerData: DefaultRadioManagerAPI.getAll,
  updateDefaultRadioManager: DefaultRadioManagerAPI.update,
};

type Payload = {
  filter: {
    /** enum: "RADIO" | "DEVICE" */
    target: string;
  }
}

async function getAccessConfigData(requestBody: Payload) {
  const data = requestBody ? requestBody : { filter: {} };
  const response = await AccessConfigAPI.post('query', data);
  return response;
}